import React from "react";
import { Sparkles, Camera, Users, ShieldCheck, Zap, Heart, Globe, X } from "./Icons";

const AboutModal = ({ isOpen, onClose, mobile, countryCode }) => {
  if (!isOpen) return null;

  return (
    // <div className="fixed inset-0 z-[70] flex items-center justify-center md:p-4 bg-black/90 backdrop-blur-md animate-in fade-in duration-300">
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center md:p-4 bg-black/90 backdrop-blur-md animate-in fade-in duration-300"
      style={{ zIndex: "100" }}
    >
      {/* <div className="glass w-full h-full md:max-w-4xl md:max-h-[90vh] md:rounded-[2.5rem] overflow-hidden flex flex-col border-white/10 shadow-2xl"> */}
      <div
        className="glass w-full h-full md:max-w-4xl md:max-h-[90vh] overflow-hidden flex flex-col border-white/10 shadow-2xl"
        style={{ borderRadius: "3rem" }}
      >
        {/* <div className="px-6 py-4 md:px-8 md:py-6 border-b border-white/5 flex justify-between items-center bg-slate-900/40"> */}
        <div
          className="px-6 py-4 md:px-8 md:py-6 border-b border-white/5 flex justify-between items-center bg-slate-900/40"
          style={{ padding: "2rem" }}
        >
          <div className="flex items-center gap-3">
            {/* <div className="w-10 h-10 bg-indigo-600 rounded-xl flex items-center justify-center shadow-lg shadow-indigo-500/20"> */}
            <div className="md:w-10 md:h-10 bg-indigo-600 rounded-xl flex items-center justify-center shadow-lg shadow-indigo-500/20">
              <Sparkles
                // className="text-white w-6 h-6"
                className="text-white w-6 md:h-6"
              />
            </div>
            <h2 className="text-xl font-bold text-white tracking-tight">About aiComposz</h2>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-full transition-all">
            <X className="md:h-6 w-6 text-slate-400" />
          </button>
        </div>

        {/* <div className="flex-1 overflow-y-auto p-6 md:p-10 space-y-12"> */}
        <div className="flex-1 overflow-y-auto md:p-10 space-y-12" style={{ padding: "5%" }}>
          <section className="space-y-6">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-sm font-medium">
              <Sparkles className="w-4 md:h-4" />
              <span>Our Story</span>
            </div>
            <h1 className="text-4xl md:text-5xl text-white font-bold tracking-tight">
              Redefining the <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 to-emerald-400">
                Digital Portrait.
              </span>
            </h1>
            <p className="text-lg text-slate-400 leading-relaxed">
              aiComposz was born from a simple observation: professional photography is expensive,
              time-consuming, and often inaccessible. We believed that state-of-the-art AI could
              bridge this gap, not by replacing photographers, but by providing a powerful tool for
              everyone to create studio-quality portraits from the comfort of their homes.
            </p>
          </section>

          <div className="grid md:grid-cols-2 gap-6 py-6">
            {/* <div className="p-8 rounded-3xl bg-slate-800/50 border border-slate-700"> */}
            <div
              className="rounded-3xl bg-slate-800/50 border border-slate-700 space-y-4"
              style={{ padding: "1rem" }}
            >
              <div className="w-12 h-12 bg-indigo-500/10 rounded-xl flex items-center justify-center mb-6">
                <Camera className="w-6 md:h-6 text-indigo-400" />
              </div>
              <h3 className="text-xl text-white font-bold mb-4">The Mission</h3>
              <p className="text-slate-400 text-sm leading-relaxed">
                Our mission is to democratize high-end portraiture. Whether it's a LinkedIn
                headshot, a family reunion photo, or a creative fashion shoot, we provide the
                technology to make it happen with surgical precision and artistic flair.
              </p>
            </div>
            {/* <div className="p-8 rounded-3xl bg-slate-800/50 border border-slate-700"> */}
            <div
              className="rounded-3xl bg-slate-800/50 border border-slate-700 space-y-4"
              style={{ padding: "1rem" }}
            >
              <div className="w-12 h-12 bg-emerald-500/10 rounded-xl flex items-center justify-center mb-6">
                <ShieldCheck className="w-6 md:h-6 text-emerald-400" />
              </div>
              <h3 className="text-xl text-white font-bold mb-4">The Technology</h3>
              <p className="text-slate-400 text-sm leading-relaxed">
                Powered by Gemini 3 Pro and our proprietary "Identity Lock" architecture, aiComposz
                ensures that your unique features are preserved while transforming the environment,
                attire, and composition around you.
              </p>
            </div>
          </div>

          <section className="space-y-8 py-6">
            <h2 className="text-3xl text-white font-bold">Why Choose Us?</h2>
            <div className="grid gap-6">
              {/* <div className="p-8 rounded-3xl bg-gradient-to-br from-slate-800/50 to-slate-900/50 border border-white/5 relative overflow-hidden group"> */}
              <div
                className="rounded-3xl bg-gradient-to-br from-slate-800/50 to-slate-900/50 border border-white/5 relative overflow-hidden group"
                style={{ padding: "5%" }}
              >
                {/* <div className="absolute top-0 right-0 p-8 opacity-5 group-hover:opacity-10 transition-opacity"> */}
                <div
                  className="absolute top-0 opacity-1 group-hover:opacity-10 transition-opacity"
                  style={{ padding: "5%", display: "flex", justifyContent: "end" }}
                >
                  <Zap className="w-140 h-140 text-indigo-400" />
                </div>
                <div className="relative z-10 space-y-4">
                  <h4 className="text-xl font-bold text-indigo-400">
                    Breaking the Subscription Cycle
                  </h4>
                  <p className="text-slate-300 leading-relaxed">
                    Whilst there are thousands of AI tools available for image generation—including
                    powerful models like Google Gemini 3 Pro—nearly all of them demand recurring
                    subscriptions or high upfront costs for massive credit bundles.
                  </p>
                  <p className="text-slate-400 text-sm leading-relaxed">
                    <strong>aiComposz</strong> changes the game with a transparent, low
                    pay-as-you-go model. No commitments, no waste—just professional results when you
                    need them.
                  </p>
                </div>
              </div>

              {/* <div className="p-8 rounded-3xl bg-gradient-to-br from-slate-800/50 to-slate-900/50 border border-white/5 relative overflow-hidden group"> */}
              <div
                className="rounded-3xl bg-gradient-to-br from-slate-800/50 to-slate-900/50 border border-white/5 relative overflow-hidden group"
                style={{ padding: "5%" }}
              >
                {/* <div className="absolute top-0 right-0 p-8 opacity-5 group-hover:opacity-10 transition-opacity"> */}
                <div
                  className="absolute top-0 opacity-1 group-hover:opacity-10 transition-opacity"
                  style={{ padding: "5%", display: "flex", justifyContent: "end" }}
                >
                  <Sparkles className="w-140 h-140 text-emerald-400" />
                </div>
                <div className="relative z-10 space-y-4">
                  <h4 className="text-xl font-bold text-emerald-400">Prompting Simplified</h4>
                  <p className="text-slate-300 leading-relaxed">
                    Most AI platforms force you to become a "prompt engineer," requiring pages of
                    lengthy, technical descriptions to get a decent result. We believe the
                    technology should work for you, not the other way around.
                  </p>
                  <p className="text-slate-400 text-sm leading-relaxed">
                    We automate the complex prompting necessary to maintain your unique{" "}
                    <strong>identity</strong> and style. By providing an intuitive way to add
                    reference images, we only ask for brief, simple prompts to turn your vision into
                    a masterpiece.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="space-y-8">
            <h2 className="text-3xl text-white font-bold">What Makes Us Different?</h2>
            <div className="space-y-6">
              {[
                {
                  icon: <Users className="w-5 md:h-5 text-indigo-400" />,
                  title: "Group Synthesis",
                  desc: "We are the first AI studio to offer true group portrait synthesis, allowing you to combine individual source photos into a single, cohesive masterpiece.",
                },
                {
                  icon: <Zap className="w-5 md:h-5 text-emerald-400" />,
                  title: "Replication Engine",
                  desc: "Our Style Builder doesn't just apply filters; it replicates specific attire, jewelry, and postures from your reference images with 1:1 fidelity.",
                },
                {
                  icon: <Globe className="w-5 md:h-5 text-cyan-400" />,
                  title: "Global Accessibility",
                  desc: `No subscriptions, no hidden fees. We operate on a pay-per-generation model starting at just ${
                    countryCode !== "IN" ? "$1" : "₹45"
                  }, making professional art accessible to everyone, everywhere.`,
                },
              ].map((feature, idx) => (
                <div
                  key={idx}
                  // className="flex gap-6 p-6 rounded-2xl bg-slate-900/50 border border-white/5"
                  className="flex gap-6 rounded-2xl bg-slate-900/50 border border-white/5"
                  style={{ padding: "2rem" }}
                >
                  {/* <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-slate-800 flex items-center justify-center"> */}
                  <div
                    className="flex-shrink-0 md:w-10 md:h-10 rounded-lg bg-slate-800 flex items-center justify-center"
                    style={{ height: mobile ? "40px" : "", width: mobile ? "40px" : "" }}
                  >
                    {feature.icon}
                  </div>
                  <div>
                    <h4 className="text-lg text-white font-bold mb-1">{feature.title}</h4>
                    <p className="text-slate-400 text-sm leading-relaxed">{feature.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="pt-6 text-center mt-30">
            {/* <div className="p-10 rounded-[2.5rem] bg-indigo-600 relative overflow-hidden"> */}
            <div
              className=" rounded-[2rem] bg-indigo-600 relative overflow-hidden"
              style={{ padding: "3rem" }}
            >
              {/* <div className="absolute top-0 right-0 p-8 opacity-10"> */}
              <div
                className="absolute top-0 opacity-10"
                style={{ padding: "1rem", display: "flex", justifyContent: "end" }}
              >
                <Heart className="w-100 h-100 text-white" />
              </div>
              <h2 className="text-2xl md:text-3xl font-bold mb-4 text-white">
                Ready to create your masterpiece?
              </h2>
              <p className="text-indigo-100 max-w-xl mx-auto text-sm">
                Join thousands of users who are already using aiComposz to redefine their digital
                presence.
              </p>
            </div>
          </section>
        </div>

        <div className="px-6 py-6 md:px-8 md:py-6 border-t border-white/5 bg-slate-900/80 flex justify-end">
          <button
            onClick={onClose}
            className="w-full sm:w-auto px-8 py-3 bg-indigo-600 hover:bg-indigo-500 text-white font-bold text-xs tracking-widest rounded-xl shadow-lg transition-all active:scale-95"
          >
            CLOSE
          </button>
        </div>
      </div>
    </div>
  );
};

export default AboutModal;
